module.exports = __webpack_public_path__ + "static/media/pandape.f0e84970.svg";